export default "__VITE_ASSET__9c6d2a50__"